var ImageChanger = (function () {
  

  Utility.log('ImageChanger.js loaded');

  var debounceResize = $.noop;

  function init() {
    setOnResize();
    onResize();
  }

  function setOnResize() {
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }

  function onResize() {

    clearTimeout(debounceResize);
    debounceResize = setTimeout(findImages, 250);
  }

  function findImages() {
    if (window.devicePixelRatio > 1) {
      var breakPImages;
      var lowresImages = $('picture');
      var bpCurrent = getCurrentBreakpoint();

      lowresImages.each(function (i) {
        switch (bpCurrent) {
          case 'sm': breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 550px)"]');
            break;
          case 'lg': breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 1024px)"]');
            break;
          case 'xl': breakPImages = $(lowresImages[i]).find('source[media|="(min-width: 1400px)"]');
            break;
          default: breakPImages = $(lowresImages[i]).find('img');
            break;
        }

        var lowres = $(breakPImages).attr('data-attribute-image1x');

        if (lowres && lowres !== '') {
          var imageToChange = $(this).find('img');

          $(imageToChange).attr('src', lowres);
        }
      });
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  return {
    init: init,
    onResize: onResize,
  };
}());
